<template>
	<div class="period-table">
		<v-flex xs6 md3>
			<BaseSelect
				return-object
				label="Año"
				item-text="year"
				item-value="id"
				:items="years"
				v-model="year"
				@input="$emit('set-year', $event)"
			/>
		</v-flex>
		<app-table
			class="is-not-selectable margin-top-responsive"
			:current-page="currentPage"
			:last-page="lastPage"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			name="accounting-periods"
			:columns="columns"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="is-not-selectable col1">
					{{ props.row.code }}
				</td>
				<td class="col2" v-show="showRow(columns, 2)">{{ props.row.startDate | exactDate }}</td>
				<td class="col3" v-show="showRow(columns, 3)">{{ props.row.deadline | exactDate }}</td>
				<td class="col4" v-show="showRow(columns, 4)">{{ props.row.datePresentation | exactDate }}</td>
				<td class="col5" v-show="showRow(columns, 5)">
					<span class="name-label">#Registros: </span>
					<span class="value-td">{{ props.row.numberRecords }}</span>
				</td>
				<td class="col6" v-show="showRow(columns, 6)">
					<span class="name-label">#Asientos: </span>
					<span class="value-td">{{ props.row.numberSeats }}</span>
				</td>
				<td class="col7" v-show="showRow(columns, 7)">
					<app-tooltip-button
						class="action-table-responsive"
						:img="selectStateImg(props.row)"
						:width="25"
						:text="statusName(props.row)"
					/>
				</td>
				<td class="col8" v-show="showRow(columns, 8)">
					<app-tooltip-button
						class="action-table-responsive"
						:img="iconState(props.row)"
						:width="25"
						:text="props.row.statusName"
					/>
				</td>
				<td class="col9" v-show="showRow(columns, 9)">
					<app-tooltip-button
						class="no-movil"
						color="info"
						text="Contabilización"
						img="/static/img/icons/icon-accounting-accounts.svg"
						:width="25"
						@click-icon="goTo('page-accounting-action', {
							params: { subsidiaryId, subsidiaryName, periodId: props.row.id },
							query: { periodName: props.row.code },
						})"
					/>
				<!--app-tooltip-button
						color="info"
						icon="remove_red_eye"
						text="Ver Registros"
						class="no-movil"
						:size="25"
						@click-icon="goTo('records', {
							params: { subsidiaryId, subsidiaryName, periodId: props.row.id },
							query: { periodName: props.row.code },
						})"
					/> -->
					<app-tooltip-button
						color="success"
						icon="edit"
						text="Editar Periodo"
						class="no-movil"
						:size="25"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="secondary"
						icon="lock"
						text="Bloquear"
						class="no-movil"
						:size="25"
						@click-icon="lock(props.row)"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" 	@click="goTo('page-accounting-action', {
										params: { subsidiaryId, subsidiaryName, periodId: props.row.id },
										query: { periodName: props.row.code },
									})">
										<img
											src="/static/img/icons/icon-accounting-accounts.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 cost-center">Contabilización</span>
									</v-list-tile-title>
								</v-list-tile>
								<!--<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goTo('records', {
										params: { subsidiaryId, subsidiaryName, periodId: props.row.id },
										query: { periodName: props.row.code },
									})">
										<img
											src="/static/img/icons/detail.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 cost-center">Ver Registros</span>
									</v-list-tile-title>
								</v-list-tile>-->
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="edit(props.row)">
										<img
											src="/static/img/icons/edit.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 accounting-plan">Editar Periodo</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import BaseSelect from '@/components/shared/inputs/base-select';

function selectStateImg({ flagActive }) {
	const active = '/static/img/icons/greenStatus.svg';
	const notActive = '/static/img/icons/redStatus.svg';
	return flagActive ? active : notActive;
}

function iconState({ status }) {
	const success = '/static/img/icons/flecha_azul.svg';
	const error = '/static/img/icons/apagar.svg';
	if (status) {
		return status === 1 ? success : error;
	}
	return error;
}

function edit({ id }) {
	this.goTo('accounting-period-edit', { params: { id } });
}

function lock({ id, code }) {
	this.goTo('accounting-period-lock', { params: { id, code } });
}


function onSearch(value) {
	this.$emit('on-search', value);
}

function statusName({ flagActive }) {
	return flagActive ? 'Activo' : 'Inactivo';
}

export default {
	name: 'accounting-period-list',
	components: {
		appTooltipButton,
		BaseSelect,
	},
	methods: {
		edit,
		lock,
		iconState,
		onSearch,
		selectStateImg,
		statusName,
	},
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			required: true,
		},
		subsidiaryId: [Number, String],
		subsidiaryName: String,
		year: [String, Number],
		years: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.col1 {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			border-right: 0px !important;
			display: flex;
			grid-column: 1/4;
			grid-row: 1;
			padding-right: 0px !important;
			padding-left: 7px !important;
			text-align: left !important;
			white-space: nowrap;
		}
	}

	.col2 {
		@media (max-width: 768px) {
			border-bottom: 1px solid color(primary);
			border-left: 0px;
			border-right: 0px;
			display: grid;
			grid-column: 1/4;
			grid-row: 2;
			white-space: nowrap;
			padding-left: 7px !important;
		}
	}

	.col3 {
		@media (max-width: 768px) {
			border-bottom: 1px solid color(primary);
			display: grid;
			grid-column: 4/7;
			grid-row: 2;
			white-space: nowrap;
		}
	}

	.col4 {
		@media (max-width: 768px) {
			border-bottom: 1px solid color(primary);
			border-right: 0px !important;
			display: grid;
			grid-column: 7/10;
			grid-row: 2;
			white-space: nowrap;
		}
	}

	.col5 {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			border-right: 0px !important;
			grid-column: 4/8;
			grid-row: 1;
			line-height: 2.5;
			padding-left: 0px !important;
			padding-right: 0px !important;
			text-align: left !important;
			white-space: nowrap;
		}
	}

	.col6 {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			grid-column: 8/12;
			grid-row: 1;
			line-height: 2.5;
			padding-left: 5px !important;
			padding-right: 0px !important;
			text-align: left !important;
			white-space: nowrap;
		}
	}

	.col7 {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			border-right: 0px !important;
			display: flex;
			grid-column: 12/13;
			grid-row: 1;
			justify-content: center;
			white-space: nowrap;
		}
	}

	.col8 {
		@media (max-width: 768px) {
			display:none;
			background-color: color(grey-background);
			border-right: 0px !important;
			grid-column: 13/14;
			grid-row: 1;
			justify-content: center;
			white-space: nowrap;
		}
	}

	.col9 {
		@media (max-width: 768px) {
			background-color: color(grey-background);
			border-right: 0px !important;
			grid-column: 14/15;
			grid-row: 1;
			white-space: nowrap;
		}
	}

	.name-label {
		display: none;

		@media (max-width: 768px) {
			display: inline-block;
			font-family: font(AvenirRegular);
			margin: 0;
		}
	}

	.collapse-menu {
		display: none;

		@media (max-width: 768px) {
			align-items: center;
			display: block;
			grid-column: 2/3;
			grid-row: 1;
			height: 100%;
			justify-content: center;

			.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

				.v-btn {
					background-color: color(btn-green);
					height: 18px;
					margin: 0;
					width: 18px;

					.v-icon {
						font-size: 18px;
					}
				}
			}

		}
	}

	.period-table {
		padding-top: 30px;
		margin: 0 40px;

		@media (max-width: 768px) {
			margin: 0px;
		}
	}

	.action-table-responsive {
		@media (max-width: 768px) {
			button {
				margin: 0px !important;

				img {
					width: 80% !important;
				}
			}
		}
	}

	.margin-top-responsive {
		margin-top: 30px;

		@media (max-width: 768px) {
			margin-top: 0px !important;
		}
	}

	.name-label {
		font-family: font(AvenirDemi);
	}
	.btnActions {
		margin: 0;
		background-color:#33cfc7;
		height:20px;
		width:20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting-periods/accounting-period-list.vue